import React, { useState, useEffect } from 'react';
import Nav from '../../../components/Nav'; // Adjust the import based on the actual path
import { Link } from 'react-router-dom';

const Purchase = () => {
  // State for handling loading state
  const [loading, setLoading] = useState(true);

  // Simulate a loader for 2.5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false); // Set loading to false after 2.5 seconds
    }, 2500);

    return () => clearTimeout(timer); // Clean up timer on component unmount
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <Nav /> {/* Import and display the navigation */}

      <div className="flex min-h-screen flex-col items-center justify-center p-6">
        {loading ? (
          <div className="flex flex-col items-center justify-center space-y-4">
            {/* Spinner */}
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div> 

            {/* Optional text while loading */}
            <p className="text-lg text-gray-700">Processing your purchase...</p>
          </div>
        ) : (
          <div className="bg-white p-8 rounded-lg shadow-lg text-center w-full max-w-md mx-auto">
            <h1 className="text-3xl font-semibold text-green-500 mb-4">Purchase Successful</h1>
            <p className="text-lg text-gray-700 mb-6">This is a demo purchase, all purchases are disabled!</p>
            <Link to="/"><button className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 focus:outline-none">
              Go back home
            </button></Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Purchase;